<template>

    <div v-if="!project.is_demo" :class="classes" @click="$router.push({ name: 'account.billing' })">
        <span><i class="fas fa-rocket mr-5"></i>{{ $t('labels.upgrade') }}</span>
    </div>

</template>

<style scoped lang="scss">

    .badge {
        @include font-bold(9px);
        align-items: center;
        background-color: $color-success;
        border-radius: 5px;
        color: $color-white;
        cursor: pointer;
        display: flex;
        line-height: normal;
        text-transform: uppercase;
        transition: opacity .3s;
        &.badge-sm {
            font-size: 8px;
            height: 18px;
            padding: 0 6px;
        }
        &.badge-md {
            font-size: 9px;
            height: 24px;
            padding: 0 10px;
        }
        &:hover {
            opacity: 0.9;
        }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'md',
        },
    },

    computed: {

        classes() {
            return {
                'badge': true,
                'badge-sm': this.size === 'sm',
                'badge-md': this.size === 'md',
            };
        },

    },

}

</script>
